export default "__VITE_ASSET__f80f84c3__"